export default __webpack_public_path__ + "static/media/actions_dots.6a4b1a93.svg";